import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { PageEvent } from '@angular/material';

@Component({
  selector: 'app-hackathon-question',
  templateUrl: './hackathon-question.component.html',
  styleUrls: ['./hackathon-question.component.scss']
})
export class HackathonQuestionComponent implements OnInit {
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  // MatPaginator Output
  pageEvent: PageEvent = new PageEvent();
  constructor(private spinnerService: Ng4LoadingSpinnerService) {  
      this.pageEvent.pageIndex = 0; this.pageEvent.pageSize = 10;
  }

  ngOnInit() {
  }

  getAllHackathonQuestion() {
    this.spinnerService.show();
  }

}
